import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { initFlowbite } from 'flowbite';
import { ProfileService } from 'src/app/modules/profile/profile.service';
import { ApiService } from 'src/app/services/api.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { FlowbiteService } from 'src/app/services/flowbite.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  public user: any;
  @Input() imageUrl: string = '';
  safeImageUrl: SafeUrl = '';
  defaultImageUrl: string = 'assets/images/user-profile.jpg';
  constructor(
    private api: ApiService,
    protected flowbiteService: FlowbiteService,
    private fileUploadService: FileUploadService,
    private profileService: ProfileService,
    private sanitizer: DomSanitizer
  ) {
     // Move subscription to constructor to ensure it's set up immediately
     this.fileUploadService.currentImageUrl.subscribe(url => {
      this.safeImageUrl = this.sanitizer.bypassSecurityTrustUrl(
        url || this.defaultImageUrl
      );
    });
  }


  ngOnInit(): void {
    initFlowbite()
    this.getProfileData();
  
    this.api.GET('user/me').subscribe({
      next: (response: any) => {
        this.user = response?.data?.user;
      }
    });

  }

  /**
   * Retrieves the user profile data and updates the user image URL.
   * @remarks
   * This function is called once when the component is initialized.
   * The user image URL is updated in the component and the local storage.
   * The function also handles errors and logs them to the console.
   */
  getProfileData() {
    this.profileService.profileData().subscribe({
      next: (res) => {
        if (res?.data?.user?.profile?.url) {
        const profileUrl = res?.data?.user?.profile?.url;

          this.fileUploadService.updateImageUrl(profileUrl);
          // this.localStorageService.set('profile_image', this.imageUrl);
        }
      },
      error: (error) => {
        console.error('Error fetching profile data:', error);
      }
    })

  }
   /* 
   Helper method to get safe URL
   */
   getSafeUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
